import { createGlobalStyle } from "styled-components";
import "./App.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import Home from "./Pages/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Proflie from "./Pages/Proflie";
import Video from "./Pages/Video";
import Setting from "./Pages/Setting";

library.add(fas, fab);

function App() {
  return (
    <>
      <ResetCSS />
      <BrowserRouter>
        <Routes>
          <Route path="/projectdongstagram" element={<Home />} />
          <Route path="/proflie" element={<Proflie />} />
          <Route path="/video" element={<Video />} />
          <Route path="/setting" element={<Setting />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;

const ResetCSS = createGlobalStyle`
 * {
  margin: 0;
  padding: 0;
 }

 li {
  list-style: none;
 }

 a {
  text-decoration: none;
  color:inherit
 }

img, video {
  vertical-align: top;
}

body {
  overflow-x: hidden;
  min-width: 360px;
}
`;
